ctrls = require.context('.', true, /\.coffee$/);
ctrls.keys().forEach(ctrls);
